import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BootstrapDialogAction } from '../../bootstrap-dialog-action';
import { BootstrapDialogFrame } from '../frame/bootstrap-dialog.frame';


export interface BootstrapConfirmDialogData {
	message: string,
	yesButtonText?: string,
	noButtonText?: string,
	bullets?: string[],
}


@Component({
	selector: 'confirm-dialog',
	standalone: true,
	imports: [BootstrapDialogFrame],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './bootstrap-confirm.dialog.html'
})

export class BootstrapConfirmDialog {

	activeModal = inject(NgbActiveModal);

	public readonly data = input<BootstrapConfirmDialogData>({ message: '' });

	public actions = computed<BootstrapDialogAction[]>(() => {

		return [
			{
				id: 'yes',
				enabled: true,
				visible: true,
				label: this.data().yesButtonText ?? 'Yes',
				linkType: "no-action",
				cssClass: 'btn-success',
				willCloseDialog: true,
			},
			{
				id: 'no',
				enabled: true,
				visible: true,
				label: this.data().noButtonText ?? 'No',
				cssClass: 'btn-danger',
				linkType: "no-action",
				willCloseDialog: true,
			}
		];
	});
}
